(function($, document, window) {
    'use strict';

    $(function() {
        const $header       = $( '.js-tab-group-header' );
        const $trigger      = $( '.js-tab-group-trigger' );
        const $carousel     = $( '.js-tabbed-courses' );

        $carousel.each( function() {
            const prevEl = $( this ).parent().find( '.js-tabbed-courses-nav-prev' ).toArray();
            const nextEl = $( this ).parent().find( '.js-tabbed-courses-nav-next' ).toArray();

            const swiper = new Swiper( this, {
                direction: 'horizontal',
                slidesPerView: 1.125,
                spaceBetween: 16,
                grabCursor: true,

                breakpoints: {
                    460: { slidesPerView: 1.25 },
                    580: { slidesPerView: 1.5 },
                    768: { slidesPerView: 2.25 },
                    1024: { slidesPerView: 3.5 },
                    1400: { slidesPerView: 4.5 },
                    1600: { slidesPerView: 5.5 },
                },

                navigation: {
                    prevEl: prevEl,
                    nextEl: nextEl,
                }
            } );
        } );

        $trigger.on( 'click', function() {
            window.dispatchEvent( new Event( 'resize' ) );

            const $activeTab    = $( this );
            const scrollLeft    = $header.scrollLeft();
            const tabOffsetLeft = $activeTab.position().left;

            // Calculate the target scroll position
            let targetScroll = scrollLeft + tabOffsetLeft;

            $header.animate({
                scrollLeft: targetScroll
            }, 300);
        } );
    });
})(jQuery, document, window);
